import { AnalysesContent } from '@/features/analyses/components';
import { Page, PageHeader } from '@/shared/ui/page';
import { requireInsurerUnderwritingAccess, requirePermissions } from '@/shared/utils';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { Home } from 'lucide-react';

export const Route = createFileRoute('/_app/analyses/')({
  component: RouteComponent,
  beforeLoad: async () => {
    const [hasPermission, hasUnderwritingAccess] = await Promise.all([
      requirePermissions(['policies.quotes.read']),
      requireInsurerUnderwritingAccess(),
    ]);
    if (!hasPermission || !hasUnderwritingAccess) {
      throw redirect({ to: '/dashboard' });
    }
  },
});

function RouteComponent() {
  return (
    <Page.Root>
      <Page.Breadcrumb
        items={[
          {
            label: 'Pagina Inicial',
            href: '/dashboard',
            iconLeft: <Home className='h-4 w-4' />,
          },
          { label: 'Análise de Cotações', active: true },
        ]}
      />

      <PageHeader.Root>
        <PageHeader.Main>
          <PageHeader.TitleGroup>
            <PageHeader.Title>Cotações em Análise</PageHeader.Title>
            <PageHeader.Subtitle>
              Acompanhe, envie e gerencie as análises vinculadas às cotações
            </PageHeader.Subtitle>
          </PageHeader.TitleGroup>
        </PageHeader.Main>
      </PageHeader.Root>

      <AnalysesContent />
    </Page.Root>
  );
}
